/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool usage statistics
 */
export type ToolUsage = {
  /**
   * Total call count
   */
  count: number;
  /**
   * Failed calls (4xx/5xx status)
   */
  failureCount: number;
  /**
   * Successful calls (2xx status)
   */
  successCount: number;
  /**
   * Tool URN
   */
  urn: string;
};

/** @internal */
export const ToolUsage$inboundSchema: z.ZodMiniType<ToolUsage, unknown> = z
  .pipe(
    z.object({
      count: z.int(),
      failure_count: z.int(),
      success_count: z.int(),
      urn: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "failure_count": "failureCount",
        "success_count": "successCount",
      });
    }),
  );

export function toolUsageFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsage' from JSON`,
  );
}
